module.exports = __webpack_public_path__ + "static/media/cachorro1.9c84893a.png";